const separator = "_separator_7ckbw_8";
const styles = {
  separator
};
export {
  styles as default,
  separator
};
//# sourceMappingURL=Separator.module.css.js.map
